let wasm;

let cachedUint8ArrayMemory0 = null;

function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_export_2.set(idx, obj);
    return idx;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = addToExternrefTable0(e);
        wasm.__wbindgen_exn_store(idx);
    }
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

let WASM_VECTOR_LEN = 0;

const cachedTextEncoder = (typeof TextEncoder !== 'undefined' ? new TextEncoder('utf-8') : { encode: () => { throw Error('TextEncoder not available') } } );

const encodeString = (typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
    return cachedTextEncoder.encodeInto(arg, view);
}
    : function (arg, view) {
    const buf = cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
});

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

let cachedDataViewMemory0 = null;

function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

const cachedTextDecoder = (typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-8', { ignoreBOM: true, fatal: true }) : { decode: () => { throw Error('TextDecoder not available') } } );

if (typeof TextDecoder !== 'undefined') { cachedTextDecoder.decode(); };

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_export_2.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}
/**
 * @param {string} local_brep_serialized
 * @param {number} height
 * @returns {string}
 */
export function extrudeBrepFace(local_brep_serialized, height) {
    let deferred3_0;
    let deferred3_1;
    try {
        const ptr0 = passStringToWasm0(local_brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.extrudeBrepFace(ptr0, len0, height);
        var ptr2 = ret[0];
        var len2 = ret[1];
        if (ret[3]) {
            ptr2 = 0; len2 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred3_0 = ptr2;
        deferred3_1 = len2;
        return getStringFromWasm0(ptr2, len2);
    } finally {
        wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
    }
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
}

let cachedFloat64ArrayMemory0 = null;

function getFloat64ArrayMemory0() {
    if (cachedFloat64ArrayMemory0 === null || cachedFloat64ArrayMemory0.byteLength === 0) {
        cachedFloat64ArrayMemory0 = new Float64Array(wasm.memory.buffer);
    }
    return cachedFloat64ArrayMemory0;
}

function getArrayF64FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getFloat64ArrayMemory0().subarray(ptr / 8, ptr / 8 + len);
}

function passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    for (let i = 0; i < array.length; i++) {
        const add = addToExternrefTable0(array[i]);
        getDataViewMemory0().setUint32(ptr + 4 * i, add, true);
    }
    WASM_VECTOR_LEN = array.length;
    return ptr;
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getDataViewMemory0();
    const result = [];
    for (let i = ptr; i < ptr + 4 * len; i += 4) {
        result.push(wasm.__wbindgen_export_2.get(mem.getUint32(i, true)));
    }
    wasm.__externref_drop_slice(ptr, len);
    return result;
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function passArrayF64ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 8, 8) >>> 0;
    getFloat64ArrayMemory0().set(arg, ptr / 8);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}
/**
 * Wasm entry point: offset a centreline by `width` into stroked regions via the
 * deterministic analytic offset. `centreline_flat` is `[x0,y0,z0, …]`. Returns
 * CW-outer / CCW-hole regions, canonicalised; empty (does NOT throw) when degenerate.
 * @param {Float64Array} centreline_flat
 * @param {number} width
 * @param {boolean} closed
 * @param {number} miter_limit
 * @returns {OGOffsetRegionsResult}
 */
export function offsetPolylineRegions(centreline_flat, width, closed, miter_limit) {
    const ptr0 = passArrayF64ToWasm0(centreline_flat, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.offsetPolylineRegions(ptr0, len0, width, closed, miter_limit);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return OGOffsetRegionsResult.__wrap(ret[0]);
}

/**
 * Wasm entry point: merge a GROUP of separate polylines (a crossing T / X / L
 * overlap) into one clean stroked region by nonzero-winding union of their mitered
 * bands. `polylines_json` is `[{centreline:[x,y,z,…], width, closed}, …]`. Returns
 * CW-outer / CCW-hole regions (one or more); empty when nothing is buildable.
 * @param {string} polylines_json
 * @returns {OGOffsetRegionsResult}
 */
export function offsetPolylineGroupRegions(polylines_json) {
    const ptr0 = passStringToWasm0(polylines_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.offsetPolylineGroupRegions(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return OGOffsetRegionsResult.__wrap(ret[0]);
}

/**
 * Wasm entry point for union.
 * @param {string} lhs_brep_serialized
 * @param {string} rhs_brep_serialized
 * @param {string | null} [options_json]
 * @returns {OGBooleanResult}
 */
export function booleanUnion(lhs_brep_serialized, rhs_brep_serialized, options_json) {
    const ptr0 = passStringToWasm0(lhs_brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(rhs_brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    var ptr2 = isLikeNone(options_json) ? 0 : passStringToWasm0(options_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len2 = WASM_VECTOR_LEN;
    const ret = wasm.booleanUnion(ptr0, len0, ptr1, len1, ptr2, len2);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return OGBooleanResult.__wrap(ret[0]);
}

/**
 * Wasm entry point for intersection.
 * @param {string} lhs_brep_serialized
 * @param {string} rhs_brep_serialized
 * @param {string | null} [options_json]
 * @returns {OGBooleanResult}
 */
export function booleanIntersection(lhs_brep_serialized, rhs_brep_serialized, options_json) {
    const ptr0 = passStringToWasm0(lhs_brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(rhs_brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    var ptr2 = isLikeNone(options_json) ? 0 : passStringToWasm0(options_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len2 = WASM_VECTOR_LEN;
    const ret = wasm.booleanIntersection(ptr0, len0, ptr1, len1, ptr2, len2);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return OGBooleanResult.__wrap(ret[0]);
}

/**
 * Wasm entry point for subtraction.
 * @param {string} lhs_brep_serialized
 * @param {string} rhs_brep_serialized
 * @param {string | null} [options_json]
 * @returns {OGBooleanResult}
 */
export function booleanSubtraction(lhs_brep_serialized, rhs_brep_serialized, options_json) {
    const ptr0 = passStringToWasm0(lhs_brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(rhs_brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    var ptr2 = isLikeNone(options_json) ? 0 : passStringToWasm0(options_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len2 = WASM_VECTOR_LEN;
    const ret = wasm.booleanSubtraction(ptr0, len0, ptr1, len1, ptr2, len2);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return OGBooleanResult.__wrap(ret[0]);
}

/**
 * Wasm entry point for array-backed repeated subtraction.
 * @param {string} lhs_brep_serialized
 * @param {string} cutters_brep_serialized
 * @param {string | null} [options_json]
 * @returns {OGBooleanResult}
 */
export function booleanSubtractionMany(lhs_brep_serialized, cutters_brep_serialized, options_json) {
    const ptr0 = passStringToWasm0(lhs_brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(cutters_brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    var ptr2 = isLikeNone(options_json) ? 0 : passStringToWasm0(options_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len2 = WASM_VECTOR_LEN;
    const ret = wasm.booleanSubtractionMany(ptr0, len0, ptr1, len1, ptr2, len2);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return OGBooleanResult.__wrap(ret[0]);
}

/**
 * Wasm entry point for array-backed batched union. Accepts a JSON array of
 * serialized BReps and folds them with `batch_union` in one boundary crossing.
 * @param {string} operands_brep_serialized
 * @param {string | null} [options_json]
 * @returns {OGBooleanResult}
 */
export function batchUnion(operands_brep_serialized, options_json) {
    const ptr0 = passStringToWasm0(operands_brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    var ptr1 = isLikeNone(options_json) ? 0 : passStringToWasm0(options_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    const ret = wasm.batchUnion(ptr0, len0, ptr1, len1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return OGBooleanResult.__wrap(ret[0]);
}

const Matrix3Finalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_matrix3_free(ptr >>> 0, 1));

export class Matrix3 {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Matrix3.prototype);
        obj.__wbg_ptr = ptr;
        Matrix3Finalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        Matrix3Finalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_matrix3_free(ptr, 0);
    }
    /**
     *
     *  * Create a new Matrix3 with identity elements.
     *
     */
    constructor() {
        const ret = wasm.matrix3_new();
        this.__wbg_ptr = ret >>> 0;
        Matrix3Finalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {number} m0
     * @param {number} m1
     * @param {number} m2
     * @param {number} m3
     * @param {number} m4
     * @param {number} m5
     * @param {number} m6
     * @param {number} m7
     * @param {number} m8
     * @returns {Matrix3}
     */
    set(m0, m1, m2, m3, m4, m5, m6, m7, m8) {
        const ret = wasm.matrix3_set(this.__wbg_ptr, m0, m1, m2, m3, m4, m5, m6, m7, m8);
        return Matrix3.__wrap(ret);
    }
    /**
     *
     *  * Clone the Matrix3 instance and return a new one.
     *
     * @returns {Matrix3}
     */
    clone() {
        const ret = wasm.matrix3_clone(this.__wbg_ptr);
        return Matrix3.__wrap(ret);
    }
    /**
     *
     *  * Sets the matrix element to create an identity matrix.
     *
     */
    identity() {
        wasm.matrix3_identity(this.__wbg_ptr);
    }
    /**
     *
     *  * Determinant for a 3x3 matrix.
     *  * https://en.wikipedia.org/wiki/Determinant
     *
     * @returns {number}
     */
    determinant() {
        const ret = wasm.matrix3_determinant(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Matrix3}
     */
    adjucate() {
        const ret = wasm.matrix3_adjucate(this.__wbg_ptr);
        return Matrix3.__wrap(ret);
    }
    /**
     * @returns {Matrix3 | undefined}
     */
    inverse() {
        const ret = wasm.matrix3_inverse(this.__wbg_ptr);
        return ret === 0 ? undefined : Matrix3.__wrap(ret);
    }
    /**
     * @returns {Matrix3}
     */
    transpose() {
        const ret = wasm.matrix3_transpose(this.__wbg_ptr);
        return Matrix3.__wrap(ret);
    }
}

const Matrix4Finalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_matrix4_free(ptr >>> 0, 1));
/**
 *
 * * Matrix4 Module
 * * 2D Representation of a 4x4 Matrix
 * * It's a row-major matrix.
 *
 */
export class Matrix4 {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Matrix4.prototype);
        obj.__wbg_ptr = ptr;
        Matrix4Finalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        Matrix4Finalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_matrix4_free(ptr, 0);
    }
    /**
     * @returns {Float64Array}
     */
    get elements() {
        const ret = wasm.matrix4_elements(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     *
     *  * Create a new Matrix4 with identity elements.
     *
     */
    constructor() {
        const ret = wasm.matrix4_new();
        this.__wbg_ptr = ret >>> 0;
        Matrix4Finalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {number} m0
     * @param {number} m1
     * @param {number} m2
     * @param {number} m3
     * @param {number} m4
     * @param {number} m5
     * @param {number} m6
     * @param {number} m7
     * @param {number} m8
     * @param {number} m9
     * @param {number} m10
     * @param {number} m11
     * @param {number} m12
     * @param {number} m13
     * @param {number} m14
     * @param {number} m15
     * @returns {Matrix4}
     */
    static set(m0, m1, m2, m3, m4, m5, m6, m7, m8, m9, m10, m11, m12, m13, m14, m15) {
        const ret = wasm.matrix4_set(m0, m1, m2, m3, m4, m5, m6, m7, m8, m9, m10, m11, m12, m13, m14, m15);
        return Matrix4.__wrap(ret);
    }
    /**
     *
     *  * Clone the Matrix4 instance and return a new one.
     *
     * @returns {Matrix4}
     */
    clone() {
        const ret = wasm.matrix4_clone(this.__wbg_ptr);
        return Matrix4.__wrap(ret);
    }
    /**
     *
     *  * Sets the matrix element to create an identity matrix.
     *
     */
    identity() {
        wasm.matrix4_identity(this.__wbg_ptr);
    }
    /**
     *
     *  * Determinant for a 4x4 matrix.
     *  * https://en.wikipedia.org/wiki/Determinant
     *
     * @returns {number}
     */
    determinant() {
        const ret = wasm.matrix4_determinant(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Matrix4}
     */
    adjucate() {
        const ret = wasm.matrix4_adjucate(this.__wbg_ptr);
        return Matrix4.__wrap(ret);
    }
    /**
     *
     *  * Inverse of a matrix
     *  * Returns a new Matrix4 instance.
     *  * If the determinant is zero, it returns a zero matrix.
     *  * It can be checked with is_zero() method.
     *
     * @returns {Matrix4}
     */
    inverse() {
        const ret = wasm.matrix4_inverse(this.__wbg_ptr);
        return Matrix4.__wrap(ret);
    }
    /**
     *
     *  * Multiply this matrix with another Matrix4
     *  * Returns a new Matrix4 instance
     *
     * @param {Matrix4} other
     * @returns {Matrix4}
     */
    multiply(other) {
        _assertClass(other, Matrix4);
        const ret = wasm.matrix4_multiply(this.__wbg_ptr, other.__wbg_ptr);
        return Matrix4.__wrap(ret);
    }
    /**
     *
     *  * Add another Matrix4 to this one.
     *  * Returns a new Matrix4 instance with the result.
     *
     * @param {Matrix4} incoming
     * @returns {Matrix4}
     */
    add(incoming) {
        _assertClass(incoming, Matrix4);
        const ret = wasm.matrix4_add(this.__wbg_ptr, incoming.__wbg_ptr);
        return Matrix4.__wrap(ret);
    }
    /**
     *
     *  * Subtract another Matrix4 from this one.
     *  * Returns a new Matrix4 instance with the result.
     *
     * @param {Matrix4} incoming
     * @returns {Matrix4}
     */
    subtract(incoming) {
        _assertClass(incoming, Matrix4);
        const ret = wasm.matrix4_subtract(this.__wbg_ptr, incoming.__wbg_ptr);
        return Matrix4.__wrap(ret);
    }
    /**
     *
     *  * Flatten the matrix into a vector of f64.
     *
     * @returns {Float64Array}
     */
    flatten() {
        const ret = wasm.matrix4_flatten(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     *
     *  * Get the element at a specific index in the flattened matrix.
     *
     * @param {number} index
     * @returns {number | undefined}
     */
    get_element_at(index) {
        const ret = wasm.matrix4_get_element_at(this.__wbg_ptr, index);
        return ret[0] === 0 ? undefined : ret[1];
    }
    /**
     *
     *  * Check if the matrix is a zero matrix.
     *
     * @returns {boolean}
     */
    is_zero() {
        const ret = wasm.matrix4_is_zero(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     *
     *  * Check if the matrix is an identity matrix.
     *
     * @returns {boolean}
     */
    is_identity() {
        const ret = wasm.matrix4_is_identity(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     *
     *  * Create a Transpose of the matrix.
     *  * Returns a new Matrix4 instance.
     *
     * @returns {Matrix4}
     */
    transpose() {
        const ret = wasm.matrix4_transpose(this.__wbg_ptr);
        return Matrix4.__wrap(ret);
    }
}

const OGArcFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogarc_free(ptr >>> 0, 1));

export class OGArc {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGArcFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogarc_free(ptr, 0);
    }
    /**
     * @param {string} id
     */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogarc_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogarc_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} id
     */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogarc_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        OGArcFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {Vector3} center
     * @param {number} radius
     * @param {number} start_angle
     * @param {number} end_angle
     * @param {number} segments
     */
    set_config(center, radius, start_angle, end_angle, segments) {
        _assertClass(center, Vector3);
        var ptr0 = center.__destroy_into_raw();
        const ret = wasm.ogarc_set_config(this.__wbg_ptr, ptr0, radius, start_angle, end_angle, segments);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} center
     */
    set_center(center) {
        _assertClass(center, Vector3);
        var ptr0 = center.__destroy_into_raw();
        wasm.ogarc_set_center(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} position
     * @param {Vector3} rotation
     * @param {Vector3} scale
     */
    set_transform(position, rotation, scale) {
        _assertClass(position, Vector3);
        var ptr0 = position.__destroy_into_raw();
        _assertClass(rotation, Vector3);
        var ptr1 = rotation.__destroy_into_raw();
        _assertClass(scale, Vector3);
        var ptr2 = scale.__destroy_into_raw();
        const ret = wasm.ogarc_set_transform(this.__wbg_ptr, ptr0, ptr1, ptr2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} translation
     */
    set_translation(translation) {
        _assertClass(translation, Vector3);
        var ptr0 = translation.__destroy_into_raw();
        wasm.ogarc_set_translation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} rotation
     */
    set_rotation(rotation) {
        _assertClass(rotation, Vector3);
        var ptr0 = rotation.__destroy_into_raw();
        wasm.ogarc_set_rotation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} scale
     */
    set_scale(scale) {
        _assertClass(scale, Vector3);
        var ptr0 = scale.__destroy_into_raw();
        const ret = wasm.ogarc_set_scale(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    generate_geometry() {
        const ret = wasm.ogarc_generate_geometry(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    dispose_points() {
        wasm.ogarc_dispose_points(this.__wbg_ptr);
    }
    destroy() {
        wasm.ogarc_destroy(this.__wbg_ptr);
    }
    /**
     * @returns {string}
     */
    get_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogarc_get_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogarc_get_local_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogarc_get_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogarc_get_local_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    get_geometry_buffer() {
        const ret = wasm.ogarc_get_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get_local_geometry_buffer() {
        const ret = wasm.ogarc_get_local_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Vector3}
     */
    get_anchor() {
        const ret = wasm.ogarc_get_anchor(this.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
}

const OGBooleanResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogbooleanresult_free(ptr >>> 0, 1));
/**
 * Result payload returned across the wasm boundary.
 */
export class OGBooleanResult {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(OGBooleanResult.prototype);
        obj.__wbg_ptr = ptr;
        OGBooleanResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGBooleanResultFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogbooleanresult_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get brepSerialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogbooleanresult_brepSerialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get geometrySerialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogbooleanresult_geometrySerialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get outlineGeometrySerialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogbooleanresult_outlineGeometrySerialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get reportJson() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogbooleanresult_reportJson(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const OGCuboidFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogcuboid_free(ptr >>> 0, 1));

export class OGCuboid {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGCuboidFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogcuboid_free(ptr, 0);
    }
    /**
     * @param {string} id
     */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogcuboid_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcuboid_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} id
     */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogcuboid_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        OGCuboidFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {Vector3} center
     * @param {number} width
     * @param {number} height
     * @param {number} depth
     */
    set_config(center, width, height, depth) {
        _assertClass(center, Vector3);
        var ptr0 = center.__destroy_into_raw();
        const ret = wasm.ogcuboid_set_config(this.__wbg_ptr, ptr0, width, height, depth);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} center
     */
    set_center(center) {
        _assertClass(center, Vector3);
        var ptr0 = center.__destroy_into_raw();
        wasm.ogcuboid_set_center(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} position
     * @param {Vector3} rotation
     * @param {Vector3} scale
     */
    set_transform(position, rotation, scale) {
        _assertClass(position, Vector3);
        var ptr0 = position.__destroy_into_raw();
        _assertClass(rotation, Vector3);
        var ptr1 = rotation.__destroy_into_raw();
        _assertClass(scale, Vector3);
        var ptr2 = scale.__destroy_into_raw();
        const ret = wasm.ogcuboid_set_transform(this.__wbg_ptr, ptr0, ptr1, ptr2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} translation
     */
    set_translation(translation) {
        _assertClass(translation, Vector3);
        var ptr0 = translation.__destroy_into_raw();
        wasm.ogcuboid_set_translation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} rotation
     */
    set_rotation(rotation) {
        _assertClass(rotation, Vector3);
        var ptr0 = rotation.__destroy_into_raw();
        wasm.ogcuboid_set_rotation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} scale
     */
    set_scale(scale) {
        _assertClass(scale, Vector3);
        var ptr0 = scale.__destroy_into_raw();
        const ret = wasm.ogcuboid_set_scale(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    generate_geometry() {
        const ret = wasm.ogcuboid_generate_geometry(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {string}
     */
    get_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcuboid_get_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcuboid_get_local_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcuboid_get_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcuboid_get_local_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    get_geometry_buffer() {
        const ret = wasm.ogcuboid_get_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get_local_geometry_buffer() {
        const ret = wasm.ogcuboid_get_local_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {string}
     */
    get_outline_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcuboid_get_outline_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_outline_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcuboid_get_local_outline_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    get_outline_geometry_buffer() {
        const ret = wasm.ogcuboid_get_outline_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get_local_outline_geometry_buffer() {
        const ret = wasm.ogcuboid_get_local_outline_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Vector3}
     */
    get_anchor() {
        const ret = wasm.ogcuboid_get_anchor(this.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
}

const OGCurveFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogcurve_free(ptr >>> 0, 1));

export class OGCurve {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGCurveFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogcurve_free(ptr, 0);
    }
    /**
     * @param {string} id
     */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogcurve_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcurve_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} id
     */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogcurve_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        OGCurveFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {Vector3[]} control_points
     */
    set_config(control_points) {
        const ptr0 = passArrayJsValueToWasm0(control_points, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogcurve_set_config(this.__wbg_ptr, ptr0, len0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} position
     * @param {Vector3} rotation
     * @param {Vector3} scale
     */
    set_transform(position, rotation, scale) {
        _assertClass(position, Vector3);
        var ptr0 = position.__destroy_into_raw();
        _assertClass(rotation, Vector3);
        var ptr1 = rotation.__destroy_into_raw();
        _assertClass(scale, Vector3);
        var ptr2 = scale.__destroy_into_raw();
        const ret = wasm.ogcurve_set_transform(this.__wbg_ptr, ptr0, ptr1, ptr2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} translation
     */
    set_translation(translation) {
        _assertClass(translation, Vector3);
        var ptr0 = translation.__destroy_into_raw();
        wasm.ogcurve_set_translation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} rotation
     */
    set_rotation(rotation) {
        _assertClass(rotation, Vector3);
        var ptr0 = rotation.__destroy_into_raw();
        wasm.ogcurve_set_rotation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} scale
     */
    set_scale(scale) {
        _assertClass(scale, Vector3);
        var ptr0 = scale.__destroy_into_raw();
        const ret = wasm.ogcurve_set_scale(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    generate_geometry() {
        const ret = wasm.ogcurve_generate_geometry(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {string}
     */
    get_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcurve_get_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcurve_get_local_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcurve_get_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcurve_get_local_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    get_geometry_buffer() {
        const ret = wasm.ogcurve_get_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get_local_geometry_buffer() {
        const ret = wasm.ogcurve_get_local_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Vector3}
     */
    get_anchor() {
        const ret = wasm.ogcurve_get_anchor(this.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
    /**
     * @param {Vector3} anchor
     */
    set_anchor(anchor) {
        _assertClass(anchor, Vector3);
        var ptr0 = anchor.__destroy_into_raw();
        const ret = wasm.ogcurve_set_anchor(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    reset_anchor() {
        const ret = wasm.ogcurve_reset_anchor(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} distance
     * @param {number} acute_threshold_degrees
     * @param {boolean} bevel
     * @returns {string}
     */
    get_offset_serialized(distance, acute_threshold_degrees, bevel) {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcurve_get_offset_serialized(this.__wbg_ptr, distance, acute_threshold_degrees, bevel);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    dispose() {
        wasm.ogcurve_dispose(this.__wbg_ptr);
    }
}

const OGCylinderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogcylinder_free(ptr >>> 0, 1));

export class OGCylinder {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGCylinderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogcylinder_free(ptr, 0);
    }
    /**
     * @param {string} id
     */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogcylinder_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcylinder_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} id
     */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogcylinder_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        OGCylinderFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {Vector3} center
     * @param {number} radius
     * @param {number} height
     * @param {number} angle
     * @param {number} segments
     */
    set_config(center, radius, height, angle, segments) {
        _assertClass(center, Vector3);
        var ptr0 = center.__destroy_into_raw();
        const ret = wasm.ogcylinder_set_config(this.__wbg_ptr, ptr0, radius, height, angle, segments);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} center
     */
    set_center(center) {
        _assertClass(center, Vector3);
        var ptr0 = center.__destroy_into_raw();
        wasm.ogcylinder_set_center(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} position
     * @param {Vector3} rotation
     * @param {Vector3} scale
     */
    set_transform(position, rotation, scale) {
        _assertClass(position, Vector3);
        var ptr0 = position.__destroy_into_raw();
        _assertClass(rotation, Vector3);
        var ptr1 = rotation.__destroy_into_raw();
        _assertClass(scale, Vector3);
        var ptr2 = scale.__destroy_into_raw();
        const ret = wasm.ogcylinder_set_transform(this.__wbg_ptr, ptr0, ptr1, ptr2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} translation
     */
    set_translation(translation) {
        _assertClass(translation, Vector3);
        var ptr0 = translation.__destroy_into_raw();
        wasm.ogcylinder_set_translation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} rotation
     */
    set_rotation(rotation) {
        _assertClass(rotation, Vector3);
        var ptr0 = rotation.__destroy_into_raw();
        wasm.ogcylinder_set_rotation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} scale
     */
    set_scale(scale) {
        _assertClass(scale, Vector3);
        var ptr0 = scale.__destroy_into_raw();
        const ret = wasm.ogcylinder_set_scale(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    generate_brep() {
        const ret = wasm.ogcylinder_generate_brep(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    clean_geometry() {
        wasm.ogcylinder_clean_geometry(this.__wbg_ptr);
    }
    generate_geometry() {
        const ret = wasm.ogcylinder_generate_geometry(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {string}
     */
    get_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcylinder_get_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcylinder_get_local_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcylinder_get_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcylinder_get_local_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    get_geometry_buffer() {
        const ret = wasm.ogcylinder_get_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get_local_geometry_buffer() {
        const ret = wasm.ogcylinder_get_local_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {string}
     */
    get_outline_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcylinder_get_outline_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_outline_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogcylinder_get_local_outline_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    get_outline_geometry_buffer() {
        const ret = wasm.ogcylinder_get_outline_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get_local_outline_geometry_buffer() {
        const ret = wasm.ogcylinder_get_local_outline_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Vector3}
     */
    get_anchor() {
        const ret = wasm.ogcylinder_get_anchor(this.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
}

const OGEntityRegistryFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogentityregistry_free(ptr >>> 0, 1));
/**
 * Flat entity registry with a batched multi-view projection API.
 * Replaces the scene-centric OGSceneManager pattern for export use cases.
 */
export class OGEntityRegistry {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGEntityRegistryFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogentityregistry_free(ptr, 0);
    }
    constructor() {
        const ret = wasm.ogentityregistry_new();
        this.__wbg_ptr = ret >>> 0;
        OGEntityRegistryFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Register (or replace) an entity. `kind` must be an OGEntityKind string.
     * @param {string} id
     * @param {string} kind
     * @param {string} brep_json
     */
    registerEntity(id, kind, brep_json) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(kind, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(brep_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.ogentityregistry_registerEntity(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * Remove a previously registered entity.
     * @param {string} id
     * @returns {boolean}
     */
    unregisterEntity(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogentityregistry_unregisterEntity(this.__wbg_ptr, ptr0, len0);
        return ret !== 0;
    }
    /**
     * Remove all registered entities.
     */
    clearEntities() {
        wasm.ogentityregistry_clearEntities(this.__wbg_ptr);
    }
    /**
     * Batched multi-view projection.
     *
     * Input:  JSON array of `{ id, camera, hlr?, section_plane? }` (ViewRequest).
     * Output: JSON map of `{ viewportId: Scene2D }`.
     *
     * All viewports are projected in a single WASM call, amortising
     * serialisation overhead and keeping BRep data in WASM memory.
     * @param {string} views_json
     * @returns {string}
     */
    projectCurrentToViews(views_json) {
        let deferred3_0;
        let deferred3_1;
        try {
            const ptr0 = passStringToWasm0(views_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ret = wasm.ogentityregistry_projectCurrentToViews(this.__wbg_ptr, ptr0, len0);
            var ptr2 = ret[0];
            var len2 = ret[1];
            if (ret[3]) {
                ptr2 = 0; len2 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
}

const OGFreeformEditorFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogfreeformeditor_free(ptr >>> 0, 1));

export class OGFreeformEditor {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGFreeformEditorFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogfreeformeditor_free(ptr, 0);
    }
    constructor() {
        const ret = wasm.ogfreeformeditor_new();
        this.__wbg_ptr = ret >>> 0;
        OGFreeformEditorFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @returns {string}
     */
    getTopologyRenderData(geometry) {
        let deferred2_0;
        let deferred2_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            const ret = wasm.ogfreeformeditor_getTopologyRenderData(this.__wbg_ptr, geometry.__wbg_ptr);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0; len1 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @param {number} face_id
     * @returns {string}
     */
    getFaceInfo(geometry, face_id) {
        let deferred2_0;
        let deferred2_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            const ret = wasm.ogfreeformeditor_getFaceInfo(this.__wbg_ptr, geometry.__wbg_ptr, face_id);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0; len1 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @param {number} edge_id
     * @returns {string}
     */
    getEdgeInfo(geometry, edge_id) {
        let deferred2_0;
        let deferred2_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            const ret = wasm.ogfreeformeditor_getEdgeInfo(this.__wbg_ptr, geometry.__wbg_ptr, edge_id);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0; len1 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @param {number} vertex_id
     * @returns {string}
     */
    getVertexInfo(geometry, vertex_id) {
        let deferred2_0;
        let deferred2_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            const ret = wasm.ogfreeformeditor_getVertexInfo(this.__wbg_ptr, geometry.__wbg_ptr, vertex_id);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0; len1 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @returns {string}
     */
    getEditCapabilities(geometry) {
        let deferred2_0;
        let deferred2_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            const ret = wasm.ogfreeformeditor_getEditCapabilities(this.__wbg_ptr, geometry.__wbg_ptr);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0; len1 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @param {number} face_id
     * @returns {string}
     */
    getFaceEditCapabilities(geometry, face_id) {
        let deferred2_0;
        let deferred2_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            const ret = wasm.ogfreeformeditor_getFaceEditCapabilities(this.__wbg_ptr, geometry.__wbg_ptr, face_id);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0; len1 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @param {number} edge_id
     * @returns {string}
     */
    getEdgeEditCapabilities(geometry, edge_id) {
        let deferred2_0;
        let deferred2_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            const ret = wasm.ogfreeformeditor_getEdgeEditCapabilities(this.__wbg_ptr, geometry.__wbg_ptr, edge_id);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0; len1 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @param {number} vertex_id
     * @returns {string}
     */
    getVertexEditCapabilities(geometry, vertex_id) {
        let deferred2_0;
        let deferred2_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            const ret = wasm.ogfreeformeditor_getVertexEditCapabilities(this.__wbg_ptr, geometry.__wbg_ptr, vertex_id);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0; len1 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @param {number} face_id
     * @param {number} distance
     * @param {string | null} [options_json]
     * @returns {string}
     */
    pushPullFace(geometry, face_id, distance, options_json) {
        let deferred3_0;
        let deferred3_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            var ptr0 = isLikeNone(options_json) ? 0 : passStringToWasm0(options_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len0 = WASM_VECTOR_LEN;
            const ret = wasm.ogfreeformeditor_pushPullFace(this.__wbg_ptr, geometry.__wbg_ptr, face_id, distance, ptr0, len0);
            var ptr2 = ret[0];
            var len2 = ret[1];
            if (ret[3]) {
                ptr2 = 0; len2 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @param {number} face_id
     * @param {Vector3} translation
     * @param {string | null} [options_json]
     * @returns {string}
     */
    moveFace(geometry, face_id, translation, options_json) {
        let deferred4_0;
        let deferred4_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            _assertClass(translation, Vector3);
            var ptr0 = translation.__destroy_into_raw();
            var ptr1 = isLikeNone(options_json) ? 0 : passStringToWasm0(options_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            const ret = wasm.ogfreeformeditor_moveFace(this.__wbg_ptr, geometry.__wbg_ptr, face_id, ptr0, ptr1, len1);
            var ptr3 = ret[0];
            var len3 = ret[1];
            if (ret[3]) {
                ptr3 = 0; len3 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred4_0 = ptr3;
            deferred4_1 = len3;
            return getStringFromWasm0(ptr3, len3);
        } finally {
            wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
        }
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @param {number} edge_id
     * @param {Vector3} translation
     * @param {string | null} [options_json]
     * @returns {string}
     */
    moveEdge(geometry, edge_id, translation, options_json) {
        let deferred4_0;
        let deferred4_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            _assertClass(translation, Vector3);
            var ptr0 = translation.__destroy_into_raw();
            var ptr1 = isLikeNone(options_json) ? 0 : passStringToWasm0(options_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            const ret = wasm.ogfreeformeditor_moveEdge(this.__wbg_ptr, geometry.__wbg_ptr, edge_id, ptr0, ptr1, len1);
            var ptr3 = ret[0];
            var len3 = ret[1];
            if (ret[3]) {
                ptr3 = 0; len3 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred4_0 = ptr3;
            deferred4_1 = len3;
            return getStringFromWasm0(ptr3, len3);
        } finally {
            wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
        }
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @param {number} vertex_id
     * @param {Vector3} translation
     * @param {string | null} [options_json]
     * @returns {string}
     */
    moveVertex(geometry, vertex_id, translation, options_json) {
        let deferred4_0;
        let deferred4_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            _assertClass(translation, Vector3);
            var ptr0 = translation.__destroy_into_raw();
            var ptr1 = isLikeNone(options_json) ? 0 : passStringToWasm0(options_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            const ret = wasm.ogfreeformeditor_moveVertex(this.__wbg_ptr, geometry.__wbg_ptr, vertex_id, ptr0, ptr1, len1);
            var ptr3 = ret[0];
            var len3 = ret[1];
            if (ret[3]) {
                ptr3 = 0; len3 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred4_0 = ptr3;
            deferred4_1 = len3;
            return getStringFromWasm0(ptr3, len3);
        } finally {
            wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
        }
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @param {number} face_id
     * @param {number} distance
     * @param {string | null} [options_json]
     * @returns {string}
     */
    extrudeFace(geometry, face_id, distance, options_json) {
        let deferred3_0;
        let deferred3_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            var ptr0 = isLikeNone(options_json) ? 0 : passStringToWasm0(options_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len0 = WASM_VECTOR_LEN;
            const ret = wasm.ogfreeformeditor_extrudeFace(this.__wbg_ptr, geometry.__wbg_ptr, face_id, distance, ptr0, len0);
            var ptr2 = ret[0];
            var len2 = ret[1];
            if (ret[3]) {
                ptr2 = 0; len2 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @param {number} face_id
     * @param {number} start_edge_id
     * @param {number} start_t
     * @param {number} end_edge_id
     * @param {number} end_t
     * @param {string | null} [options_json]
     * @returns {string}
     */
    cutFace(geometry, face_id, start_edge_id, start_t, end_edge_id, end_t, options_json) {
        let deferred3_0;
        let deferred3_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            var ptr0 = isLikeNone(options_json) ? 0 : passStringToWasm0(options_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len0 = WASM_VECTOR_LEN;
            const ret = wasm.ogfreeformeditor_cutFace(this.__wbg_ptr, geometry.__wbg_ptr, face_id, start_edge_id, start_t, end_edge_id, end_t, ptr0, len0);
            var ptr2 = ret[0];
            var len2 = ret[1];
            if (ret[3]) {
                ptr2 = 0; len2 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @param {number} edge_id
     * @param {number} t
     * @param {string | null} [options_json]
     * @returns {string}
     */
    insertVertexOnEdge(geometry, edge_id, t, options_json) {
        let deferred3_0;
        let deferred3_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            var ptr0 = isLikeNone(options_json) ? 0 : passStringToWasm0(options_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len0 = WASM_VECTOR_LEN;
            const ret = wasm.ogfreeformeditor_insertVertexOnEdge(this.__wbg_ptr, geometry.__wbg_ptr, edge_id, t, ptr0, len0);
            var ptr2 = ret[0];
            var len2 = ret[1];
            if (ret[3]) {
                ptr2 = 0; len2 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @param {number} edge_id
     * @param {number} t
     * @param {string | null} [options_json]
     * @returns {string}
     */
    splitEdge(geometry, edge_id, t, options_json) {
        let deferred3_0;
        let deferred3_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            var ptr0 = isLikeNone(options_json) ? 0 : passStringToWasm0(options_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len0 = WASM_VECTOR_LEN;
            const ret = wasm.ogfreeformeditor_splitEdge(this.__wbg_ptr, geometry.__wbg_ptr, edge_id, t, ptr0, len0);
            var ptr2 = ret[0];
            var len2 = ret[1];
            if (ret[3]) {
                ptr2 = 0; len2 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @param {number} edge_id
     * @param {number} t
     * @param {string | null} [options_json]
     * @returns {string}
     */
    loopCut(geometry, edge_id, t, options_json) {
        let deferred3_0;
        let deferred3_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            var ptr0 = isLikeNone(options_json) ? 0 : passStringToWasm0(options_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len0 = WASM_VECTOR_LEN;
            const ret = wasm.ogfreeformeditor_loopCut(this.__wbg_ptr, geometry.__wbg_ptr, edge_id, t, ptr0, len0);
            var ptr2 = ret[0];
            var len2 = ret[1];
            if (ret[3]) {
                ptr2 = 0; len2 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
     * @param {OGFreeformGeometry} geometry
     * @param {number} vertex_id
     * @param {string | null} [options_json]
     * @returns {string}
     */
    removeVertex(geometry, vertex_id, options_json) {
        let deferred3_0;
        let deferred3_1;
        try {
            _assertClass(geometry, OGFreeformGeometry);
            var ptr0 = isLikeNone(options_json) ? 0 : passStringToWasm0(options_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len0 = WASM_VECTOR_LEN;
            const ret = wasm.ogfreeformeditor_removeVertex(this.__wbg_ptr, geometry.__wbg_ptr, vertex_id, ptr0, len0);
            var ptr2 = ret[0];
            var len2 = ret[1];
            if (ret[3]) {
                ptr2 = 0; len2 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
}

const OGFreeformGeometryFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogfreeformgeometry_free(ptr >>> 0, 1));

export class OGFreeformGeometry {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGFreeformGeometryFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogfreeformgeometry_free(ptr, 0);
    }
    /**
     * @param {string} id
     * @param {string} local_brep_serialized
     */
    constructor(id, local_brep_serialized) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(local_brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.ogfreeformgeometry_new(ptr0, len0, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        this.__wbg_ptr = ret[0] >>> 0;
        OGFreeformGeometryFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogfreeformgeometry_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    getBrepSerialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogfreeformgeometry_getBrepSerialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    getLocalBrepSerialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogfreeformgeometry_getLocalBrepSerialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    getGeometrySerialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogfreeformgeometry_getGeometrySerialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    getGeometryBuffer() {
        const ret = wasm.ogfreeformgeometry_getGeometryBuffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    getLocalGeometryBuffer() {
        const ret = wasm.ogfreeformgeometry_getLocalGeometryBuffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {string}
     */
    getOutlineGeometrySerialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogfreeformgeometry_getOutlineGeometrySerialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    getOutlineGeometryBuffer() {
        const ret = wasm.ogfreeformgeometry_getOutlineGeometryBuffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    getLocalOutlineGeometryBuffer() {
        const ret = wasm.ogfreeformgeometry_getLocalOutlineGeometryBuffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {string}
     */
    getPlacementSerialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogfreeformgeometry_getPlacementSerialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} placement_serialized
     */
    setPlacementSerialized(placement_serialized) {
        const ptr0 = passStringToWasm0(placement_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogfreeformgeometry_setPlacementSerialized(this.__wbg_ptr, ptr0, len0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} translation
     * @param {Vector3} rotation
     * @param {Vector3} scale
     */
    setTransform(translation, rotation, scale) {
        _assertClass(translation, Vector3);
        var ptr0 = translation.__destroy_into_raw();
        _assertClass(rotation, Vector3);
        var ptr1 = rotation.__destroy_into_raw();
        _assertClass(scale, Vector3);
        var ptr2 = scale.__destroy_into_raw();
        const ret = wasm.ogfreeformgeometry_setTransform(this.__wbg_ptr, ptr0, ptr1, ptr2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} translation
     */
    setTranslation(translation) {
        _assertClass(translation, Vector3);
        var ptr0 = translation.__destroy_into_raw();
        wasm.ogfreeformgeometry_setTranslation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} rotation
     */
    setRotation(rotation) {
        _assertClass(rotation, Vector3);
        var ptr0 = rotation.__destroy_into_raw();
        wasm.ogfreeformgeometry_setRotation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} scale
     */
    setScale(scale) {
        _assertClass(scale, Vector3);
        var ptr0 = scale.__destroy_into_raw();
        const ret = wasm.ogfreeformgeometry_setScale(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} anchor
     */
    setAnchor(anchor) {
        _assertClass(anchor, Vector3);
        var ptr0 = anchor.__destroy_into_raw();
        wasm.ogfreeformgeometry_setAnchor(this.__wbg_ptr, ptr0);
    }
}

const OGIfcExportResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogifcexportresult_free(ptr >>> 0, 1));

export class OGIfcExportResult {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(OGIfcExportResult.prototype);
        obj.__wbg_ptr = ptr;
        OGIfcExportResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGIfcExportResultFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogifcexportresult_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get text() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogifcexportresult_text(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get reportJson() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogifcexportresult_reportJson(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const OGLineFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogline_free(ptr >>> 0, 1));

export class OGLine {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGLineFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogline_free(ptr, 0);
    }
    /**
     * @param {string} id
     */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogline_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogline_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} id
     */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogline_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        OGLineFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {Vector3} start
     * @param {Vector3} end
     */
    set_config(start, end) {
        _assertClass(start, Vector3);
        var ptr0 = start.__destroy_into_raw();
        _assertClass(end, Vector3);
        var ptr1 = end.__destroy_into_raw();
        const ret = wasm.ogline_set_config(this.__wbg_ptr, ptr0, ptr1);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} position
     * @param {Vector3} rotation
     * @param {Vector3} scale
     */
    set_transform(position, rotation, scale) {
        _assertClass(position, Vector3);
        var ptr0 = position.__destroy_into_raw();
        _assertClass(rotation, Vector3);
        var ptr1 = rotation.__destroy_into_raw();
        _assertClass(scale, Vector3);
        var ptr2 = scale.__destroy_into_raw();
        const ret = wasm.ogline_set_transform(this.__wbg_ptr, ptr0, ptr1, ptr2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} translation
     */
    set_translation(translation) {
        _assertClass(translation, Vector3);
        var ptr0 = translation.__destroy_into_raw();
        wasm.ogline_set_translation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} rotation
     */
    set_rotation(rotation) {
        _assertClass(rotation, Vector3);
        var ptr0 = rotation.__destroy_into_raw();
        wasm.ogline_set_rotation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} scale
     */
    set_scale(scale) {
        _assertClass(scale, Vector3);
        var ptr0 = scale.__destroy_into_raw();
        const ret = wasm.ogline_set_scale(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    generate_geometry() {
        const ret = wasm.ogline_generate_geometry(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    dispose_points() {
        wasm.ogline_dispose_points(this.__wbg_ptr);
    }
    destroy() {
        wasm.ogline_destroy(this.__wbg_ptr);
    }
    /**
     * @returns {string}
     */
    get_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogline_get_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogline_get_local_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogline_get_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogline_get_local_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    get_geometry_buffer() {
        const ret = wasm.ogline_get_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get_local_geometry_buffer() {
        const ret = wasm.ogline_get_local_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Vector3}
     */
    get_anchor() {
        const ret = wasm.ogline_get_anchor(this.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
    /**
     * @param {Vector3} anchor
     */
    set_anchor(anchor) {
        _assertClass(anchor, Vector3);
        var ptr0 = anchor.__destroy_into_raw();
        const ret = wasm.ogline_set_anchor(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    reset_anchor() {
        const ret = wasm.ogline_reset_anchor(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} distance
     * @param {number} acute_threshold_degrees
     * @param {boolean} bevel
     * @returns {string}
     */
    get_offset_serialized(distance, acute_threshold_degrees, bevel) {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogline_get_offset_serialized(this.__wbg_ptr, distance, acute_threshold_degrees, bevel);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_dxf_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogline_get_dxf_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const OGOffsetRegionsResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogoffsetregionsresult_free(ptr >>> 0, 1));
/**
 * Result payload for a polyline offset: a list of regions (each an outer ring +
 * inner-void holes). Normally one region; a self-crossing closed centreline (e.g.
 * a figure-8) yields one per simple sub-loop. The deterministic analytic offset —
 * no extrude/solid. Used to build the plan polygons + extruded base solids in JS.
 */
export class OGOffsetRegionsResult {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(OGOffsetRegionsResult.prototype);
        obj.__wbg_ptr = ptr;
        OGOffsetRegionsResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGOffsetRegionsResultFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogoffsetregionsresult_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get regionsSerialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogoffsetregionsresult_regionsSerialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const OGPolygonFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogpolygon_free(ptr >>> 0, 1));

export class OGPolygon {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGPolygonFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogpolygon_free(ptr, 0);
    }
    /**
     * @param {string} id
     */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogpolygon_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogpolygon_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} id
     */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogpolygon_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        OGPolygonFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {Vector3[]} points
     */
    set_config(points) {
        const ptr0 = passArrayJsValueToWasm0(points, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogpolygon_set_config(this.__wbg_ptr, ptr0, len0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} position
     * @param {Vector3} rotation
     * @param {Vector3} scale
     */
    set_transform(position, rotation, scale) {
        _assertClass(position, Vector3);
        var ptr0 = position.__destroy_into_raw();
        _assertClass(rotation, Vector3);
        var ptr1 = rotation.__destroy_into_raw();
        _assertClass(scale, Vector3);
        var ptr2 = scale.__destroy_into_raw();
        const ret = wasm.ogpolygon_set_transform(this.__wbg_ptr, ptr0, ptr1, ptr2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} translation
     */
    set_translation(translation) {
        _assertClass(translation, Vector3);
        var ptr0 = translation.__destroy_into_raw();
        wasm.ogpolygon_set_translation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} rotation
     */
    set_rotation(rotation) {
        _assertClass(rotation, Vector3);
        var ptr0 = rotation.__destroy_into_raw();
        wasm.ogpolygon_set_rotation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} scale
     */
    set_scale(scale) {
        _assertClass(scale, Vector3);
        var ptr0 = scale.__destroy_into_raw();
        const ret = wasm.ogpolygon_set_scale(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3[]} vertices
     */
    add_vertices(vertices) {
        const ptr0 = passArrayJsValueToWasm0(vertices, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogpolygon_add_vertices(this.__wbg_ptr, ptr0, len0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3[]} hole
     */
    add_holes(hole) {
        const ptr0 = passArrayJsValueToWasm0(hole, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogpolygon_add_holes(this.__wbg_ptr, ptr0, len0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    clean_geometry() {
        wasm.ogpolygon_clean_geometry(this.__wbg_ptr);
    }
    generate_brep() {
        const ret = wasm.ogpolygon_generate_brep(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    generate_geometry() {
        const ret = wasm.ogpolygon_generate_geometry(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {string}
     */
    get_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogpolygon_get_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogpolygon_get_local_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogpolygon_get_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogpolygon_get_local_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    get_geometry_buffer() {
        const ret = wasm.ogpolygon_get_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get_local_geometry_buffer() {
        const ret = wasm.ogpolygon_get_local_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {string}
     */
    get_outline_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogpolygon_get_outline_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_outline_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogpolygon_get_local_outline_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    get_outline_geometry_buffer() {
        const ret = wasm.ogpolygon_get_outline_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get_local_outline_geometry_buffer() {
        const ret = wasm.ogpolygon_get_local_outline_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Vector3}
     */
    get_anchor() {
        const ret = wasm.ogpolygon_get_anchor(this.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
    /**
     * @param {Vector3} anchor
     */
    set_anchor(anchor) {
        _assertClass(anchor, Vector3);
        var ptr0 = anchor.__destroy_into_raw();
        const ret = wasm.ogpolygon_set_anchor(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    reset_anchor() {
        const ret = wasm.ogpolygon_reset_anchor(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
}

const OGPolylineFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogpolyline_free(ptr >>> 0, 1));

export class OGPolyline {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(OGPolyline.prototype);
        obj.__wbg_ptr = ptr;
        OGPolylineFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGPolylineFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogpolyline_free(ptr, 0);
    }
    /**
     * @param {string} id
     */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogpolyline_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogpolyline_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} id
     */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogpolyline_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        OGPolylineFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {OGPolyline}
     */
    clone() {
        const ret = wasm.ogpolyline_clone(this.__wbg_ptr);
        return OGPolyline.__wrap(ret);
    }
    /**
     * @param {Vector3[]} points
     */
    set_config(points) {
        const ptr0 = passArrayJsValueToWasm0(points, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogpolyline_set_config(this.__wbg_ptr, ptr0, len0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} position
     * @param {Vector3} rotation
     * @param {Vector3} scale
     */
    set_transform(position, rotation, scale) {
        _assertClass(position, Vector3);
        var ptr0 = position.__destroy_into_raw();
        _assertClass(rotation, Vector3);
        var ptr1 = rotation.__destroy_into_raw();
        _assertClass(scale, Vector3);
        var ptr2 = scale.__destroy_into_raw();
        const ret = wasm.ogpolyline_set_transform(this.__wbg_ptr, ptr0, ptr1, ptr2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} translation
     */
    set_translation(translation) {
        _assertClass(translation, Vector3);
        var ptr0 = translation.__destroy_into_raw();
        wasm.ogpolyline_set_translation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} rotation
     */
    set_rotation(rotation) {
        _assertClass(rotation, Vector3);
        var ptr0 = rotation.__destroy_into_raw();
        wasm.ogpolyline_set_rotation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} scale
     */
    set_scale(scale) {
        _assertClass(scale, Vector3);
        var ptr0 = scale.__destroy_into_raw();
        const ret = wasm.ogpolyline_set_scale(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    generate_geometry() {
        const ret = wasm.ogpolyline_generate_geometry(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3[]} points
     */
    add_multiple_points(points) {
        const ptr0 = passArrayJsValueToWasm0(points, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogpolyline_add_multiple_points(this.__wbg_ptr, ptr0, len0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} point
     */
    add_point(point) {
        _assertClass(point, Vector3);
        var ptr0 = point.__destroy_into_raw();
        const ret = wasm.ogpolyline_add_point(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {string}
     */
    get_points() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogpolyline_get_points(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Vector3[]}
     */
    get_raw_points() {
        const ret = wasm.ogpolyline_get_raw_points(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {boolean}
     */
    is_closed() {
        const ret = wasm.ogpolyline_is_closed(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {number} distance
     * @param {number} acute_threshold_degrees
     * @param {boolean} bevel
     * @returns {string}
     */
    get_offset_serialized(distance, acute_threshold_degrees, bevel) {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogpolyline_get_offset_serialized(this.__wbg_ptr, distance, acute_threshold_degrees, bevel);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    check_closed_test() {
        wasm.ogpolyline_check_closed_test(this.__wbg_ptr);
    }
    /**
     * @returns {string}
     */
    get_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogpolyline_get_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogpolyline_get_local_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogpolyline_get_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogpolyline_get_local_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    get_geometry_buffer() {
        const ret = wasm.ogpolyline_get_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get_local_geometry_buffer() {
        const ret = wasm.ogpolyline_get_local_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Vector3}
     */
    get_anchor() {
        const ret = wasm.ogpolyline_get_anchor(this.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
    /**
     * @param {Vector3} anchor
     */
    set_anchor(anchor) {
        _assertClass(anchor, Vector3);
        var ptr0 = anchor.__destroy_into_raw();
        const ret = wasm.ogpolyline_set_anchor(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    reset_anchor() {
        const ret = wasm.ogpolyline_reset_anchor(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
}

const OGRectangleFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogrectangle_free(ptr >>> 0, 1));

export class OGRectangle {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGRectangleFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogrectangle_free(ptr, 0);
    }
    /**
     * @param {string} id
     */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogrectangle_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogrectangle_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} id
     */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogrectangle_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        OGRectangleFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {Vector3} center
     * @param {number} width
     * @param {number} breadth
     */
    set_config(center, width, breadth) {
        _assertClass(center, Vector3);
        var ptr0 = center.__destroy_into_raw();
        const ret = wasm.ogrectangle_set_config(this.__wbg_ptr, ptr0, width, breadth);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} center
     */
    set_center(center) {
        _assertClass(center, Vector3);
        var ptr0 = center.__destroy_into_raw();
        wasm.ogrectangle_set_center(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} position
     * @param {Vector3} rotation
     * @param {Vector3} scale
     */
    set_transform(position, rotation, scale) {
        _assertClass(position, Vector3);
        var ptr0 = position.__destroy_into_raw();
        _assertClass(rotation, Vector3);
        var ptr1 = rotation.__destroy_into_raw();
        _assertClass(scale, Vector3);
        var ptr2 = scale.__destroy_into_raw();
        const ret = wasm.ogrectangle_set_transform(this.__wbg_ptr, ptr0, ptr1, ptr2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} translation
     */
    set_translation(translation) {
        _assertClass(translation, Vector3);
        var ptr0 = translation.__destroy_into_raw();
        wasm.ogrectangle_set_translation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} rotation
     */
    set_rotation(rotation) {
        _assertClass(rotation, Vector3);
        var ptr0 = rotation.__destroy_into_raw();
        wasm.ogrectangle_set_rotation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} scale
     */
    set_scale(scale) {
        _assertClass(scale, Vector3);
        var ptr0 = scale.__destroy_into_raw();
        const ret = wasm.ogrectangle_set_scale(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    generate_geometry() {
        const ret = wasm.ogrectangle_generate_geometry(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {string}
     */
    get_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogrectangle_get_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogrectangle_get_local_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogrectangle_get_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogrectangle_get_local_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    get_geometry_buffer() {
        const ret = wasm.ogrectangle_get_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get_local_geometry_buffer() {
        const ret = wasm.ogrectangle_get_local_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Vector3}
     */
    get_anchor() {
        const ret = wasm.ogrectangle_get_anchor(this.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
    /**
     * @param {number} distance
     * @param {number} acute_threshold_degrees
     * @param {boolean} bevel
     * @returns {string}
     */
    get_offset_serialized(distance, acute_threshold_degrees, bevel) {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogrectangle_get_offset_serialized(this.__wbg_ptr, distance, acute_threshold_degrees, bevel);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const OGSceneManagerFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogscenemanager_free(ptr >>> 0, 1));

export class OGSceneManager {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGSceneManagerFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogscenemanager_free(ptr, 0);
    }
    constructor() {
        const ret = wasm.ogscenemanager_new();
        this.__wbg_ptr = ret >>> 0;
        OGSceneManagerFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {string} name
     * @returns {string}
     */
    createScene(name) {
        let deferred2_0;
        let deferred2_1;
        try {
            const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ret = wasm.ogscenemanager_createScene(this.__wbg_ptr, ptr0, len0);
            deferred2_0 = ret[0];
            deferred2_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @param {string} scene_id
     * @returns {boolean}
     */
    removeScene(scene_id) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_removeScene(this.__wbg_ptr, ptr0, len0);
        return ret !== 0;
    }
    /**
     * @param {string} scene_id
     */
    setCurrentScene(scene_id) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_setCurrentScene(this.__wbg_ptr, ptr0, len0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {string | undefined}
     */
    getCurrentSceneId() {
        const ret = wasm.ogscenemanager_getCurrentSceneId(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {string}
     */
    listScenes() {
        let deferred2_0;
        let deferred2_1;
        try {
            const ret = wasm.ogscenemanager_listScenes(this.__wbg_ptr);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0; len1 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @param {string} scene_id
     * @returns {string}
     */
    getSceneSerialized(scene_id) {
        let deferred3_0;
        let deferred3_1;
        try {
            const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ret = wasm.ogscenemanager_getSceneSerialized(this.__wbg_ptr, ptr0, len0);
            var ptr2 = ret[0];
            var len2 = ret[1];
            if (ret[3]) {
                ptr2 = 0; len2 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
     * @param {string} scene_id
     * @param {string} entity_id
     * @returns {boolean}
     */
    removeEntityFromScene(scene_id, entity_id) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_removeEntityFromScene(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * @param {string} scene_id
     * @param {string} entity_id
     * @param {string} kind
     * @param {string} brep_serialized
     */
    addBrepEntityToScene(scene_id, entity_id, kind, brep_serialized) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(kind, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ptr3 = passStringToWasm0(brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len3 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_addBrepEntityToScene(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} entity_id
     * @param {string} kind
     * @param {string} brep_serialized
     */
    addBrepEntityToCurrentScene(entity_id, kind, brep_serialized) {
        const ptr0 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(kind, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_addBrepEntityToCurrentScene(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} scene_id
     * @param {string} entity_id
     * @param {string} kind
     * @param {string} brep_serialized
     */
    replaceBrepEntityInScene(scene_id, entity_id, kind, brep_serialized) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(kind, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ptr3 = passStringToWasm0(brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len3 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_replaceBrepEntityInScene(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} entity_id
     * @param {string} kind
     * @param {string} brep_serialized
     */
    replaceBrepEntityInCurrentScene(entity_id, kind, brep_serialized) {
        const ptr0 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(kind, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_replaceBrepEntityInCurrentScene(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} scene_id
     * @param {string} entity_id
     * @param {string} kind
     * @param {string} brep_serialized
     */
    refreshBrepEntityInScene(scene_id, entity_id, kind, brep_serialized) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(kind, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ptr3 = passStringToWasm0(brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len3 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_refreshBrepEntityInScene(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} entity_id
     * @param {string} kind
     * @param {string} brep_serialized
     */
    refreshBrepEntityInCurrentScene(entity_id, kind, brep_serialized) {
        const ptr0 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(kind, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_refreshBrepEntityInCurrentScene(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} scene_id
     * @param {string} entity_id
     * @param {OGLine} line
     */
    addLineToScene(scene_id, entity_id, line) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        _assertClass(line, OGLine);
        const ret = wasm.ogscenemanager_addLineToScene(this.__wbg_ptr, ptr0, len0, ptr1, len1, line.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} entity_id
     * @param {OGLine} line
     */
    addLineToCurrentScene(entity_id, line) {
        const ptr0 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        _assertClass(line, OGLine);
        const ret = wasm.ogscenemanager_addLineToCurrentScene(this.__wbg_ptr, ptr0, len0, line.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} scene_id
     * @param {string} entity_id
     * @param {OGPolyline} polyline
     */
    addPolylineToScene(scene_id, entity_id, polyline) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        _assertClass(polyline, OGPolyline);
        const ret = wasm.ogscenemanager_addPolylineToScene(this.__wbg_ptr, ptr0, len0, ptr1, len1, polyline.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} entity_id
     * @param {OGPolyline} polyline
     */
    addPolylineToCurrentScene(entity_id, polyline) {
        const ptr0 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        _assertClass(polyline, OGPolyline);
        const ret = wasm.ogscenemanager_addPolylineToCurrentScene(this.__wbg_ptr, ptr0, len0, polyline.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} scene_id
     * @param {string} entity_id
     * @param {OGArc} arc
     */
    addArcToScene(scene_id, entity_id, arc) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        _assertClass(arc, OGArc);
        const ret = wasm.ogscenemanager_addArcToScene(this.__wbg_ptr, ptr0, len0, ptr1, len1, arc.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} entity_id
     * @param {OGArc} arc
     */
    addArcToCurrentScene(entity_id, arc) {
        const ptr0 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        _assertClass(arc, OGArc);
        const ret = wasm.ogscenemanager_addArcToCurrentScene(this.__wbg_ptr, ptr0, len0, arc.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} scene_id
     * @param {string} entity_id
     * @param {OGRectangle} rectangle
     */
    addRectangleToScene(scene_id, entity_id, rectangle) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        _assertClass(rectangle, OGRectangle);
        const ret = wasm.ogscenemanager_addRectangleToScene(this.__wbg_ptr, ptr0, len0, ptr1, len1, rectangle.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} entity_id
     * @param {OGRectangle} rectangle
     */
    addRectangleToCurrentScene(entity_id, rectangle) {
        const ptr0 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        _assertClass(rectangle, OGRectangle);
        const ret = wasm.ogscenemanager_addRectangleToCurrentScene(this.__wbg_ptr, ptr0, len0, rectangle.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} scene_id
     * @param {string} entity_id
     * @param {OGPolygon} polygon
     */
    addPolygonToScene(scene_id, entity_id, polygon) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        _assertClass(polygon, OGPolygon);
        const ret = wasm.ogscenemanager_addPolygonToScene(this.__wbg_ptr, ptr0, len0, ptr1, len1, polygon.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} entity_id
     * @param {OGPolygon} polygon
     */
    addPolygonToCurrentScene(entity_id, polygon) {
        const ptr0 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        _assertClass(polygon, OGPolygon);
        const ret = wasm.ogscenemanager_addPolygonToCurrentScene(this.__wbg_ptr, ptr0, len0, polygon.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} scene_id
     * @param {string} entity_id
     * @param {OGCuboid} cuboid
     */
    addCuboidToScene(scene_id, entity_id, cuboid) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        _assertClass(cuboid, OGCuboid);
        const ret = wasm.ogscenemanager_addCuboidToScene(this.__wbg_ptr, ptr0, len0, ptr1, len1, cuboid.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} entity_id
     * @param {OGCuboid} cuboid
     */
    addCuboidToCurrentScene(entity_id, cuboid) {
        const ptr0 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        _assertClass(cuboid, OGCuboid);
        const ret = wasm.ogscenemanager_addCuboidToCurrentScene(this.__wbg_ptr, ptr0, len0, cuboid.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} scene_id
     * @param {string} entity_id
     * @param {OGCylinder} cylinder
     */
    addCylinderToScene(scene_id, entity_id, cylinder) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        _assertClass(cylinder, OGCylinder);
        const ret = wasm.ogscenemanager_addCylinderToScene(this.__wbg_ptr, ptr0, len0, ptr1, len1, cylinder.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} entity_id
     * @param {OGCylinder} cylinder
     */
    addCylinderToCurrentScene(entity_id, cylinder) {
        const ptr0 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        _assertClass(cylinder, OGCylinder);
        const ret = wasm.ogscenemanager_addCylinderToCurrentScene(this.__wbg_ptr, ptr0, len0, cylinder.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} scene_id
     * @param {string} entity_id
     * @param {OGSphere} sphere
     */
    addSphereToScene(scene_id, entity_id, sphere) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        _assertClass(sphere, OGSphere);
        const ret = wasm.ogscenemanager_addSphereToScene(this.__wbg_ptr, ptr0, len0, ptr1, len1, sphere.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} entity_id
     * @param {OGSphere} sphere
     */
    addSphereToCurrentScene(entity_id, sphere) {
        const ptr0 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        _assertClass(sphere, OGSphere);
        const ret = wasm.ogscenemanager_addSphereToCurrentScene(this.__wbg_ptr, ptr0, len0, sphere.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} scene_id
     * @param {string} entity_id
     * @param {OGWedge} wedge
     */
    addWedgeToScene(scene_id, entity_id, wedge) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        _assertClass(wedge, OGWedge);
        const ret = wasm.ogscenemanager_addWedgeToScene(this.__wbg_ptr, ptr0, len0, ptr1, len1, wedge.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} entity_id
     * @param {OGWedge} wedge
     */
    addWedgeToCurrentScene(entity_id, wedge) {
        const ptr0 = passStringToWasm0(entity_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        _assertClass(wedge, OGWedge);
        const ret = wasm.ogscenemanager_addWedgeToCurrentScene(this.__wbg_ptr, ptr0, len0, wedge.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} scene_id
     * @param {string} camera_json
     * @param {string | null} [hlr_json]
     * @returns {string}
     */
    projectTo2DCamera(scene_id, camera_json, hlr_json) {
        let deferred5_0;
        let deferred5_1;
        try {
            const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(camera_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            var ptr2 = isLikeNone(hlr_json) ? 0 : passStringToWasm0(hlr_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len2 = WASM_VECTOR_LEN;
            const ret = wasm.ogscenemanager_projectTo2DCamera(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
            var ptr4 = ret[0];
            var len4 = ret[1];
            if (ret[3]) {
                ptr4 = 0; len4 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred5_0 = ptr4;
            deferred5_1 = len4;
            return getStringFromWasm0(ptr4, len4);
        } finally {
            wasm.__wbindgen_free(deferred5_0, deferred5_1, 1);
        }
    }
    /**
     * @param {string} scene_id
     * @param {string} camera_json
     * @param {string | null} [hlr_json]
     * @returns {string}
     */
    projectTo2DCameraPretty(scene_id, camera_json, hlr_json) {
        let deferred5_0;
        let deferred5_1;
        try {
            const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(camera_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            var ptr2 = isLikeNone(hlr_json) ? 0 : passStringToWasm0(hlr_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len2 = WASM_VECTOR_LEN;
            const ret = wasm.ogscenemanager_projectTo2DCameraPretty(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
            var ptr4 = ret[0];
            var len4 = ret[1];
            if (ret[3]) {
                ptr4 = 0; len4 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred5_0 = ptr4;
            deferred5_1 = len4;
            return getStringFromWasm0(ptr4, len4);
        } finally {
            wasm.__wbindgen_free(deferred5_0, deferred5_1, 1);
        }
    }
    /**
     * @param {string} scene_id
     * @param {string} camera_json
     * @param {string | null} [hlr_json]
     * @returns {string}
     */
    projectTo2DLines(scene_id, camera_json, hlr_json) {
        let deferred5_0;
        let deferred5_1;
        try {
            const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(camera_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            var ptr2 = isLikeNone(hlr_json) ? 0 : passStringToWasm0(hlr_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len2 = WASM_VECTOR_LEN;
            const ret = wasm.ogscenemanager_projectTo2DLines(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
            var ptr4 = ret[0];
            var len4 = ret[1];
            if (ret[3]) {
                ptr4 = 0; len4 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred5_0 = ptr4;
            deferred5_1 = len4;
            return getStringFromWasm0(ptr4, len4);
        } finally {
            wasm.__wbindgen_free(deferred5_0, deferred5_1, 1);
        }
    }
    /**
     * @param {string} scene_id
     * @param {string} camera_json
     * @param {string | null} [hlr_json]
     * @returns {string}
     */
    projectTo2DLinesPretty(scene_id, camera_json, hlr_json) {
        let deferred5_0;
        let deferred5_1;
        try {
            const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(camera_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            var ptr2 = isLikeNone(hlr_json) ? 0 : passStringToWasm0(hlr_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len2 = WASM_VECTOR_LEN;
            const ret = wasm.ogscenemanager_projectTo2DLinesPretty(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
            var ptr4 = ret[0];
            var len4 = ret[1];
            if (ret[3]) {
                ptr4 = 0; len4 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred5_0 = ptr4;
            deferred5_1 = len4;
            return getStringFromWasm0(ptr4, len4);
        } finally {
            wasm.__wbindgen_free(deferred5_0, deferred5_1, 1);
        }
    }
    /**
     * @param {string} camera_json
     * @param {string | null} [hlr_json]
     * @returns {string}
     */
    projectCurrentTo2DCamera(camera_json, hlr_json) {
        let deferred4_0;
        let deferred4_1;
        try {
            const ptr0 = passStringToWasm0(camera_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            var ptr1 = isLikeNone(hlr_json) ? 0 : passStringToWasm0(hlr_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            const ret = wasm.ogscenemanager_projectCurrentTo2DCamera(this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var ptr3 = ret[0];
            var len3 = ret[1];
            if (ret[3]) {
                ptr3 = 0; len3 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred4_0 = ptr3;
            deferred4_1 = len3;
            return getStringFromWasm0(ptr3, len3);
        } finally {
            wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
        }
    }
    /**
     * @param {string} camera_json
     * @param {string | null} [hlr_json]
     * @returns {string}
     */
    projectCurrentTo2DLines(camera_json, hlr_json) {
        let deferred4_0;
        let deferred4_1;
        try {
            const ptr0 = passStringToWasm0(camera_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            var ptr1 = isLikeNone(hlr_json) ? 0 : passStringToWasm0(hlr_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            const ret = wasm.ogscenemanager_projectCurrentTo2DLines(this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var ptr3 = ret[0];
            var len3 = ret[1];
            if (ret[3]) {
                ptr3 = 0; len3 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred4_0 = ptr3;
            deferred4_1 = len3;
            return getStringFromWasm0(ptr3, len3);
        } finally {
            wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
        }
    }
    /**
     * @param {string} brep_serialized
     * @param {string | null} [config_json]
     * @returns {OGStlExportResult}
     */
    exportBrepToStl(brep_serialized, config_json) {
        const ptr0 = passStringToWasm0(brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(config_json) ? 0 : passStringToWasm0(config_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_exportBrepToStl(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return OGStlExportResult.__wrap(ret[0]);
    }
    /**
     * @param {string} scene_id
     * @param {string | null} [config_json]
     * @returns {OGStlExportResult}
     */
    exportSceneToStl(scene_id, config_json) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(config_json) ? 0 : passStringToWasm0(config_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_exportSceneToStl(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return OGStlExportResult.__wrap(ret[0]);
    }
    /**
     * @param {string | null} [config_json]
     * @returns {OGStlExportResult}
     */
    exportCurrentSceneToStl(config_json) {
        var ptr0 = isLikeNone(config_json) ? 0 : passStringToWasm0(config_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_exportCurrentSceneToStl(this.__wbg_ptr, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return OGStlExportResult.__wrap(ret[0]);
    }
    /**
     * @param {string} brep_serialized
     * @param {string | null} [config_json]
     * @returns {OGStepExportResult}
     */
    exportBrepToStep(brep_serialized, config_json) {
        const ptr0 = passStringToWasm0(brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(config_json) ? 0 : passStringToWasm0(config_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_exportBrepToStep(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return OGStepExportResult.__wrap(ret[0]);
    }
    /**
     * @param {string} scene_id
     * @param {string | null} [config_json]
     * @returns {OGStepExportResult}
     */
    exportSceneToStep(scene_id, config_json) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(config_json) ? 0 : passStringToWasm0(config_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_exportSceneToStep(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return OGStepExportResult.__wrap(ret[0]);
    }
    /**
     * @param {string | null} [config_json]
     * @returns {OGStepExportResult}
     */
    exportCurrentSceneToStep(config_json) {
        var ptr0 = isLikeNone(config_json) ? 0 : passStringToWasm0(config_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_exportCurrentSceneToStep(this.__wbg_ptr, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return OGStepExportResult.__wrap(ret[0]);
    }
    /**
     * @param {string} brep_serialized
     * @param {string | null} [config_json]
     * @returns {OGIfcExportResult}
     */
    exportBrepToIfc(brep_serialized, config_json) {
        const ptr0 = passStringToWasm0(brep_serialized, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(config_json) ? 0 : passStringToWasm0(config_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_exportBrepToIfc(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return OGIfcExportResult.__wrap(ret[0]);
    }
    /**
     * @param {string} scene_id
     * @param {string | null} [config_json]
     * @returns {OGIfcExportResult}
     */
    exportSceneToIfc(scene_id, config_json) {
        const ptr0 = passStringToWasm0(scene_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(config_json) ? 0 : passStringToWasm0(config_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_exportSceneToIfc(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return OGIfcExportResult.__wrap(ret[0]);
    }
    /**
     * @param {string | null} [config_json]
     * @returns {OGIfcExportResult}
     */
    exportCurrentSceneToIfc(config_json) {
        var ptr0 = isLikeNone(config_json) ? 0 : passStringToWasm0(config_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogscenemanager_exportCurrentSceneToIfc(this.__wbg_ptr, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return OGIfcExportResult.__wrap(ret[0]);
    }
}

const OGSphereFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogsphere_free(ptr >>> 0, 1));

export class OGSphere {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGSphereFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogsphere_free(ptr, 0);
    }
    /**
     * @param {string} id
     */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogsphere_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogsphere_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} id
     */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogsphere_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        OGSphereFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {Vector3} center
     * @param {number} radius
     * @param {number} width_segments
     * @param {number} height_segments
     */
    set_config(center, radius, width_segments, height_segments) {
        _assertClass(center, Vector3);
        var ptr0 = center.__destroy_into_raw();
        const ret = wasm.ogsphere_set_config(this.__wbg_ptr, ptr0, radius, width_segments, height_segments);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} center
     */
    set_center(center) {
        _assertClass(center, Vector3);
        var ptr0 = center.__destroy_into_raw();
        wasm.ogsphere_set_center(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} position
     * @param {Vector3} rotation
     * @param {Vector3} scale
     */
    set_transform(position, rotation, scale) {
        _assertClass(position, Vector3);
        var ptr0 = position.__destroy_into_raw();
        _assertClass(rotation, Vector3);
        var ptr1 = rotation.__destroy_into_raw();
        _assertClass(scale, Vector3);
        var ptr2 = scale.__destroy_into_raw();
        const ret = wasm.ogsphere_set_transform(this.__wbg_ptr, ptr0, ptr1, ptr2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} translation
     */
    set_translation(translation) {
        _assertClass(translation, Vector3);
        var ptr0 = translation.__destroy_into_raw();
        wasm.ogsphere_set_translation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} rotation
     */
    set_rotation(rotation) {
        _assertClass(rotation, Vector3);
        var ptr0 = rotation.__destroy_into_raw();
        wasm.ogsphere_set_rotation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} scale
     */
    set_scale(scale) {
        _assertClass(scale, Vector3);
        var ptr0 = scale.__destroy_into_raw();
        const ret = wasm.ogsphere_set_scale(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    generate_brep() {
        const ret = wasm.ogsphere_generate_brep(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    clean_geometry() {
        wasm.ogsphere_clean_geometry(this.__wbg_ptr);
    }
    generate_geometry() {
        const ret = wasm.ogsphere_generate_geometry(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {string}
     */
    get_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogsphere_get_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogsphere_get_local_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogsphere_get_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogsphere_get_local_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    get_geometry_buffer() {
        const ret = wasm.ogsphere_get_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get_local_geometry_buffer() {
        const ret = wasm.ogsphere_get_local_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {string}
     */
    get_outline_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogsphere_get_outline_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_outline_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogsphere_get_local_outline_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    get_outline_geometry_buffer() {
        const ret = wasm.ogsphere_get_outline_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get_local_outline_geometry_buffer() {
        const ret = wasm.ogsphere_get_local_outline_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Vector3}
     */
    get_anchor() {
        const ret = wasm.ogsphere_get_anchor(this.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
}

const OGStepExportResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogstepexportresult_free(ptr >>> 0, 1));

export class OGStepExportResult {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(OGStepExportResult.prototype);
        obj.__wbg_ptr = ptr;
        OGStepExportResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGStepExportResultFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogstepexportresult_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get text() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogstepexportresult_text(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get reportJson() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogstepexportresult_reportJson(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const OGStlExportResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogstlexportresult_free(ptr >>> 0, 1));

export class OGStlExportResult {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(OGStlExportResult.prototype);
        obj.__wbg_ptr = ptr;
        OGStlExportResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGStlExportResultFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogstlexportresult_free(ptr, 0);
    }
    /**
     * @returns {Uint8Array}
     */
    get bytes() {
        const ret = wasm.ogstlexportresult_bytes(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {string}
     */
    get reportJson() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogstlexportresult_reportJson(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const OGSweepFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogsweep_free(ptr >>> 0, 1));

export class OGSweep {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGSweepFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogsweep_free(ptr, 0);
    }
    /**
     * @param {string} id
     */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogsweep_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogsweep_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} id
     */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogsweep_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        OGSweepFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {Vector3[]} path_points
     * @param {Vector3[]} profile_points
     */
    set_config(path_points, profile_points) {
        const ptr0 = passArrayJsValueToWasm0(path_points, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayJsValueToWasm0(profile_points, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.ogsweep_set_config(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3[]} path_points
     * @param {Vector3[]} profile_points
     * @param {boolean} cap_start
     * @param {boolean} cap_end
     */
    set_config_with_caps(path_points, profile_points, cap_start, cap_end) {
        const ptr0 = passArrayJsValueToWasm0(path_points, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayJsValueToWasm0(profile_points, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.ogsweep_set_config_with_caps(this.__wbg_ptr, ptr0, len0, ptr1, len1, cap_start, cap_end);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {boolean} cap_start
     * @param {boolean} cap_end
     */
    set_caps(cap_start, cap_end) {
        const ret = wasm.ogsweep_set_caps(this.__wbg_ptr, cap_start, cap_end);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} position
     * @param {Vector3} rotation
     * @param {Vector3} scale
     */
    set_transform(position, rotation, scale) {
        _assertClass(position, Vector3);
        var ptr0 = position.__destroy_into_raw();
        _assertClass(rotation, Vector3);
        var ptr1 = rotation.__destroy_into_raw();
        _assertClass(scale, Vector3);
        var ptr2 = scale.__destroy_into_raw();
        const ret = wasm.ogsweep_set_transform(this.__wbg_ptr, ptr0, ptr1, ptr2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} translation
     */
    set_translation(translation) {
        _assertClass(translation, Vector3);
        var ptr0 = translation.__destroy_into_raw();
        wasm.ogsweep_set_translation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} rotation
     */
    set_rotation(rotation) {
        _assertClass(rotation, Vector3);
        var ptr0 = rotation.__destroy_into_raw();
        wasm.ogsweep_set_rotation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} scale
     */
    set_scale(scale) {
        _assertClass(scale, Vector3);
        var ptr0 = scale.__destroy_into_raw();
        const ret = wasm.ogsweep_set_scale(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    generate_brep() {
        const ret = wasm.ogsweep_generate_brep(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    clean_geometry() {
        wasm.ogsweep_clean_geometry(this.__wbg_ptr);
    }
    generate_geometry() {
        const ret = wasm.ogsweep_generate_geometry(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {string}
     */
    get_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogsweep_get_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogsweep_get_local_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogsweep_get_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogsweep_get_local_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    get_geometry_buffer() {
        const ret = wasm.ogsweep_get_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get_local_geometry_buffer() {
        const ret = wasm.ogsweep_get_local_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {string}
     */
    get_outline_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogsweep_get_outline_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_outline_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogsweep_get_local_outline_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    get_outline_geometry_buffer() {
        const ret = wasm.ogsweep_get_outline_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get_local_outline_geometry_buffer() {
        const ret = wasm.ogsweep_get_local_outline_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Vector3}
     */
    get_anchor() {
        const ret = wasm.ogsweep_get_anchor(this.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
    /**
     * @param {Vector3} anchor
     */
    set_anchor(anchor) {
        _assertClass(anchor, Vector3);
        var ptr0 = anchor.__destroy_into_raw();
        const ret = wasm.ogsweep_set_anchor(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    reset_anchor() {
        const ret = wasm.ogsweep_reset_anchor(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
}

const OGWedgeFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogwedge_free(ptr >>> 0, 1));

export class OGWedge {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGWedgeFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogwedge_free(ptr, 0);
    }
    /**
     * @param {string} id
     */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogwedge_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogwedge_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} id
     */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogwedge_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        OGWedgeFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {Vector3} center
     * @param {number} width
     * @param {number} height
     * @param {number} depth
     */
    set_config(center, width, height, depth) {
        _assertClass(center, Vector3);
        var ptr0 = center.__destroy_into_raw();
        const ret = wasm.ogwedge_set_config(this.__wbg_ptr, ptr0, width, height, depth);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} center
     */
    set_center(center) {
        _assertClass(center, Vector3);
        var ptr0 = center.__destroy_into_raw();
        wasm.ogwedge_set_center(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} position
     * @param {Vector3} rotation
     * @param {Vector3} scale
     */
    set_transform(position, rotation, scale) {
        _assertClass(position, Vector3);
        var ptr0 = position.__destroy_into_raw();
        _assertClass(rotation, Vector3);
        var ptr1 = rotation.__destroy_into_raw();
        _assertClass(scale, Vector3);
        var ptr2 = scale.__destroy_into_raw();
        const ret = wasm.ogwedge_set_transform(this.__wbg_ptr, ptr0, ptr1, ptr2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {Vector3} translation
     */
    set_translation(translation) {
        _assertClass(translation, Vector3);
        var ptr0 = translation.__destroy_into_raw();
        wasm.ogwedge_set_translation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} rotation
     */
    set_rotation(rotation) {
        _assertClass(rotation, Vector3);
        var ptr0 = rotation.__destroy_into_raw();
        wasm.ogwedge_set_rotation(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {Vector3} scale
     */
    set_scale(scale) {
        _assertClass(scale, Vector3);
        var ptr0 = scale.__destroy_into_raw();
        const ret = wasm.ogwedge_set_scale(this.__wbg_ptr, ptr0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    generate_brep() {
        const ret = wasm.ogwedge_generate_brep(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    clean_geometry() {
        wasm.ogwedge_clean_geometry(this.__wbg_ptr);
    }
    generate_geometry() {
        const ret = wasm.ogwedge_generate_geometry(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {string}
     */
    get_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogwedge_get_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_brep_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogwedge_get_local_brep_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogwedge_get_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogwedge_get_local_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    get_geometry_buffer() {
        const ret = wasm.ogwedge_get_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get_local_geometry_buffer() {
        const ret = wasm.ogwedge_get_local_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {string}
     */
    get_outline_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogwedge_get_outline_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get_local_outline_geometry_serialized() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.ogwedge_get_local_outline_geometry_serialized(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float64Array}
     */
    get_outline_geometry_buffer() {
        const ret = wasm.ogwedge_get_outline_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get_local_outline_geometry_buffer() {
        const ret = wasm.ogwedge_get_local_outline_geometry_buffer(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Vector3}
     */
    get_anchor() {
        const ret = wasm.ogarc_get_anchor(this.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
}

const Vector3Finalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_vector3_free(ptr >>> 0, 1));

export class Vector3 {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Vector3.prototype);
        obj.__wbg_ptr = ptr;
        Vector3Finalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    static __unwrap(jsValue) {
        if (!(jsValue instanceof Vector3)) {
            return 0;
        }
        return jsValue.__destroy_into_raw();
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        Vector3Finalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_vector3_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get x() {
        const ret = wasm.__wbg_get_vector3_x(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set x(arg0) {
        wasm.__wbg_set_vector3_x(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {number}
     */
    get y() {
        const ret = wasm.__wbg_get_vector3_y(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set y(arg0) {
        wasm.__wbg_set_vector3_y(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {number}
     */
    get z() {
        const ret = wasm.__wbg_get_vector3_z(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set z(arg0) {
        wasm.__wbg_set_vector3_z(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} x
     * @param {number} y
     * @param {number} z
     */
    constructor(x, y, z) {
        const ret = wasm.vector3_new(x, y, z);
        this.__wbg_ptr = ret >>> 0;
        Vector3Finalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     *
     *  * Add the elements of another vector to this one.
     *
     * @param {Vector3} other
     * @returns {Vector3}
     */
    add(other) {
        _assertClass(other, Vector3);
        const ret = wasm.vector3_add(this.__wbg_ptr, other.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
    /**
     *
     *  * Add a scalar value to each element of the vector.
     *
     * @param {number} scalar
     * @returns {Vector3}
     */
    add_scalar(scalar) {
        const ret = wasm.vector3_add_scalar(this.__wbg_ptr, scalar);
        return Vector3.__wrap(ret);
    }
    /**
     *
     *  * Subtract the elements of another vector from this one.
     *
     * @param {Vector3} other
     * @returns {Vector3}
     */
    subtract(other) {
        _assertClass(other, Vector3);
        const ret = wasm.vector3_subtract(this.__wbg_ptr, other.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
    /**
     *
     *  * Subtract a scalar value from each element of the vector.
     *
     * @param {number} scalar
     * @returns {Vector3}
     */
    subtract_scalar(scalar) {
        const ret = wasm.vector3_subtract_scalar(this.__wbg_ptr, scalar);
        return Vector3.__wrap(ret);
    }
    /**
     *
     *  * Clone the Vector3 instance and return a new one.
     *
     * @returns {Vector3}
     */
    clone() {
        const ret = wasm.vector3_clone(this.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
    /**
     *
     *  * Set the current vector elements to zero.
     *
     */
    zero() {
        wasm.vector3_zero(this.__wbg_ptr);
    }
    /**
     *
     *  * Copy the elements from another Vector3 instance.
     *
     * @param {Vector3} other
     */
    copy(other) {
        _assertClass(other, Vector3);
        wasm.vector3_copy(this.__wbg_ptr, other.__wbg_ptr);
    }
    /**
     *
     *  * Multiply the vector by a scalar value.
     *
     * @param {number} scalar
     * @returns {Vector3}
     */
    multiply_scalar(scalar) {
        const ret = wasm.vector3_multiply_scalar(this.__wbg_ptr, scalar);
        return Vector3.__wrap(ret);
    }
    /**
     *
     *  * Multiply the vector by another Vector3 instance element-wise.
     *
     * @param {Vector3} other
     * @returns {Vector3}
     */
    multiply(other) {
        _assertClass(other, Vector3);
        const ret = wasm.vector3_multiply(this.__wbg_ptr, other.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
    /**
     *
     *  * Divide the vector by another Vector3 instance element-wise.
     *
     * @param {Vector3} other
     * @returns {Vector3}
     */
    divide(other) {
        _assertClass(other, Vector3);
        const ret = wasm.vector3_divide(this.__wbg_ptr, other.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
    /**
     *
     *  * Divide the vector by a scalar value.
     *
     * @param {number} scalar
     * @returns {Vector3}
     */
    divide_scalar(scalar) {
        const ret = wasm.vector3_divide_scalar(this.__wbg_ptr, scalar);
        return Vector3.__wrap(ret);
    }
    /**
     *
     *  * Invert the vector by negating the vector elements.
     *
     * @returns {Vector3}
     */
    negate() {
        const ret = wasm.vector3_negate(this.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
    /**
     *
     *  * Calculate the dot product of this vector with another Vector3 instance.
     *
     * @param {Vector3} other
     * @returns {number}
     */
    dot(other) {
        _assertClass(other, Vector3);
        const ret = wasm.vector3_dot(this.__wbg_ptr, other.__wbg_ptr);
        return ret;
    }
    /**
     *
     *  * Calculate the magnitude (length) of the vector.
     *
     * @returns {number}
     */
    magnitude() {
        const ret = wasm.vector3_magnitude(this.__wbg_ptr);
        return ret;
    }
    /**
     *
     *  * Calculate the length of the vector.
     *  * Since length is equivalent to magnitude, this method is an alias.
     *
     * @returns {number}
     */
    length() {
        const ret = wasm.vector3_length(this.__wbg_ptr);
        return ret;
    }
    /**
     *
     *  * Normalize the vector
     *
     * @returns {Vector3}
     */
    normalize() {
        const ret = wasm.vector3_normalize(this.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
    /**
     *
     *  * Calculate the cross product and return the result as a new Vector3
     *
     * @param {Vector3} other
     * @returns {Vector3}
     */
    cross(other) {
        _assertClass(other, Vector3);
        const ret = wasm.vector3_cross(this.__wbg_ptr, other.__wbg_ptr);
        return Vector3.__wrap(ret);
    }
    /**
     *
     *  * Calculate the distance between this vector and another Vector3 instance.
     *  * Return the distance as a f64 value in Euclidean space.
     *
     * @param {Vector3} other
     * @returns {number}
     */
    distance(other) {
        _assertClass(other, Vector3);
        const ret = wasm.vector3_distance(this.__wbg_ptr, other.__wbg_ptr);
        return ret;
    }
    /**
     *
     *  * Apply a transformation matrix to the vector.
     *  * This method assumes the transformation matrix is a 4x4 matrix.
     *
     * @param {Matrix4} matrix
     */
    apply_matrix4(matrix) {
        _assertClass(matrix, Matrix4);
        var ptr0 = matrix.__destroy_into_raw();
        wasm.vector3_apply_matrix4(this.__wbg_ptr, ptr0);
    }
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);

            } catch (e) {
                if (module.headers.get('Content-Type') != 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else {
                    throw e;
                }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);

    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };

        } else {
            return instance;
        }
    }
}

function __wbg_get_imports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbg_getRandomValues_38097e921c2494c3 = function() { return handleError(function (arg0, arg1) {
        globalThis.crypto.getRandomValues(getArrayU8FromWasm0(arg0, arg1));
    }, arguments) };
    imports.wbg.__wbg_vector3_new = function(arg0) {
        const ret = Vector3.__wrap(arg0);
        return ret;
    };
    imports.wbg.__wbg_vector3_unwrap = function(arg0) {
        const ret = Vector3.__unwrap(arg0);
        return ret;
    };
    imports.wbg.__wbindgen_debug_string = function(arg0, arg1) {
        const ret = debugString(arg1);
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    };
    imports.wbg.__wbindgen_init_externref_table = function() {
        const table = wasm.__wbindgen_export_2;
        const offset = table.grow(4);
        table.set(0, undefined);
        table.set(offset + 0, undefined);
        table.set(offset + 1, null);
        table.set(offset + 2, true);
        table.set(offset + 3, false);
        ;
    };
    imports.wbg.__wbindgen_string_new = function(arg0, arg1) {
        const ret = getStringFromWasm0(arg0, arg1);
        return ret;
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };

    return imports;
}

function __wbg_init_memory(imports, memory) {

}

function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    __wbg_init.__wbindgen_wasm_module = module;
    cachedDataViewMemory0 = null;
    cachedFloat64ArrayMemory0 = null;
    cachedUint8ArrayMemory0 = null;


    wasm.__wbindgen_start();
    return wasm;
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (typeof module !== 'undefined') {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();

    __wbg_init_memory(imports);

    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }

    const instance = new WebAssembly.Instance(module, imports);

    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (typeof module_or_path !== 'undefined') {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (typeof module_or_path === 'undefined') {
        module_or_path = new URL('opengeometry_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    __wbg_init_memory(imports);

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync };
export default __wbg_init;
